import { render, staticRenderFns } from "./SchoolRegister.vue?vue&type=template&id=1a39fec8&"
import script from "./SchoolRegister.vue?vue&type=script&lang=js&"
export * from "./SchoolRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports